module.exports = __webpack_public_path__ + "static/img/Camera.86029ad7.svg";